/**
 * @author sai shiva
 * @Date: 2022-03-11 12:40:55
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-03-11 14:30:55
 */

import styled from 'styled-components';
import endPoints from '../../../config/endPoints';

const StyledThankYou = styled.div`
    font-family: ${(props) => props.theme.gothamRegularFont};
    overflow-x: hidden;
    .banner-thank-u{
      background: url(${endPoints.THANK_YOU_BG.URL});
      background-size: cover;
      height: 100vh;
      padding-top: 6.5rem;
    }
    .text-red{
      color: ${(props) => props.theme.primaryColor};
    }
    .card-bg{
      background: ${(props) => props.theme.mystic};
      border: none;
      border-radius: 0px;
      border-top: 5px solid ${(props) => props.theme.primaryColor};
      box-shadow: 0px 0px 24px ${(props) => props.theme.borderGray};
      a{
        color: ${(props) => props.theme.blackColor};
      }
    }
    .social-media{
       margin: 0px;
       padding: 0px;
       li{
         display: inline-block;
         list-style: none;
         a{
           color: ${({ theme }) => theme.LandingBlack};;
           font-size:12px;
           padding: 0px 5px;
           display:block;
           &:hover{
             color: ${({ theme }) => theme.primaryLight};
           }
           img{
           &.youtube{
             width: 15px;
           }
         }
       }
     }
   }
 `;
export default StyledThankYou;



// WEBPACK FOOTER //
// client/containers/StaticPages/Thankyou/StyledThankyou.js